<template>
  <nuxt-link class="card album" :to="`/albums/${data.slug}`">
    <div class="album__thumbnail" v-if="images.length > 0">
      <Swiper
        v-if="slide"
        :modules="[SwiperAutoplay]"
        :loop="true"
        :autoplay="{
          delay: 3500,
          disableOnInteraction: true
        }"
      >
        <SwiperSlide v-for="image in images.slice(0, 10)" :key="image.id">
          <nuxt-img provider="strapi" :src="getFlattenedStrapiImageLocation(image)"/>
        </SwiperSlide>
      </Swiper>
      <nuxt-img v-else provider="strapi" :src="getFlattenedStrapiImageLocation(images[0])"/>
    </div>
    <div class="album__content">
      <div class="album_banner" :class="{ private: data.private }"></div>
      <div class="album__content--inner">
        <h3 class="text--default">{{ data.title }}</h3>
        <p class="mt-05" v-if="data.extra_info">{{ data.extra_info }}</p>
      </div>
    </div>
  </nuxt-link>
</template>

<script lang="ts" setup>
import { PropType } from "nuxt/dist/app/compat/capi";
import Album from "~/typings/items/album";

const props = defineProps({
  data: {
    type: Object as PropType<Album>,
    required: true
  },
  slide: {
    type: Boolean as PropType<boolean>,
    default: false
  }
});

const images = computed(() => flattenStrapiCollection(props.data.images));
</script>

<style lang="scss">
.album {
  padding: 0;
  display: block;
  text-decoration: none;
}

.album__thumbnail {
  width: 100%;
  height: 18rem;
  border-radius: 1rem;
  overflow: hidden;

  img, picture {
    height: 100%;
    width: 100%;
    object-fit: cover;
    object-position: center;
  }
}

.album__placeloader {
  display: flex;
  justify-content: center;
  align-items: center;
}

.album__content {
  padding: 1rem;
  color: $text;
  display: flex;
  flex-direction: row;
}

.album_banner {
  width: 4px;
  background: $primary;
  flex-grow: 0;
  flex-shrink: 0;
  border-radius: 2px;

  &.private {
    background: $secondary;
  }
}

.album__content--inner {
  flex-grow: 1;
  flex-shrink: 1;
  padding: 0.5rem;
  padding-left: 1rem;
}
</style>
